import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CompanyInfoStateService } from '../../modules/contact/services/company-info-state.service';

@Component({
  selector: 'app-page-impressum',
  templateUrl: './page-impressum.component.html',
  styleUrls: ['./page-impressum.component.css']
})
export class PageImpressumComponent implements OnInit {

  constructor(
    private companyInfoStateService: CompanyInfoStateService
  ) { }

  ngOnInit() {
  }

  get shopCountry(): string {
    return environment.globalSettings.shopCountry;
  }

}
